module.exports = "https://static.im-cdn.com/mjc/storefront/Accent/static/media/Phone-call.22db71e1.svg";